import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import LoadingSpinner from '../common/LoadingSpinner';

const PrivateRoute = ({ children, requiredPermission = null }) => {
  const { currentUser, loading, hasPermission } = useAuth();
  const location = useLocation();
  
  // Afficher un indicateur de chargement pendant la vérification de l'authentification
  if (loading) {
    return <LoadingSpinner message="Vérification de l'authentification..." />;
  }
  
  // Rediriger vers la page de connexion si l'utilisateur n'est pas connecté
  if (!currentUser) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  
  // Vérifier la permission si spécifiée
  if (requiredPermission && !hasPermission(requiredPermission)) {
    // Rediriger vers la page d'accueil si l'utilisateur n'a pas la permission requise
    return <Navigate to="/access-denied" replace />;
  }
  
  // Rendre le composant enfant
  return children;
};

export default PrivateRoute;
